import { render, staticRenderFns } from "./UpdateEducationModal.vue?vue&type=template&id=4ef2c387&"
import script from "./UpdateEducationModal.vue?vue&type=script&lang=js&"
export * from "./UpdateEducationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports